import { render, staticRenderFns } from "./cms-info.vue?vue&type=template&id=2e0c9c5c"
import script from "./cms-info.vue?vue&type=script&lang=js"
export * from "./cms-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports